<script setup lang="ts">
import { useSeoHead } from '~/composables/useSeoHead'

definePageMeta({
  hideDefaultTopNav: true,
  newsCategory: 'bit_yuanchuang',
})

const { t } = useAppI18n()

useSeoHead({
  title: () => t('85597'),
  description: () => t('85595'),
  keywords: () => t('85597').replace(/\s*\|\s*WikiBit\s*$/i, ''),
})
</script>

<template>
  <NewsListContent />
</template>
